<button
  mat-button
  [matMenuTriggerFor]="menu"
  *ngIf="!selectedOption"
  class="fast-filter"
  matTooltip="Filtre por {{ name }}"
>
  {{ name }}
  <mat-icon>keyboard_arrow_down</mat-icon>
</button>
<mat-menu #menu="matMenu" (closed)="resetSelection()" class="mat-menu">
  <mat-checkbox
    *ngFor="let option of options"
    [(ngModel)]="option.selected"
    (click)="$event.stopPropagation()"
    >{{ option.label }}</mat-checkbox
  >

  <button mat-flat-button class="primary m-2" (click)="applyFilter()">
    <mat-icon>search</mat-icon>
    Filtrar
  </button>
</mat-menu>

<mat-chip *ngIf="selectedOption" (removed)="clearSelectedOption()">
  <div class="flex items-center gap-2">
    <mat-icon>check</mat-icon>
    {{ descriptionSelectedOption }}
  </div>
  <mat-icon
    matChipRemove
    matTooltip="Remover {{ name }}: {{ descriptionSelectedOption }}"
    >cancel</mat-icon
  >
</mat-chip>
